import { useEffect } from "react";
import { useStockDaily } from "../../context/StockDailyContext";
import { FaSpinner } from "react-icons/fa6";

function GlobalDaily() {
  const { dailyStore, fetchDailyData, fetchNasdaq100Daily, loading, error } =
    useStockDaily();

  /* ✅ Load NASDAQ-100 when page opens */
  useEffect(() => {
    fetchNasdaq100Daily();
  }, [fetchNasdaq100Daily]);

  if (loading && Object.keys(dailyStore).length === 0) {
    return <p style={{ color: "white" }}>Loading NASDAQ 100 data...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }
  console.log("Data from context", dailyStore);

  return (
    <>
      {loading ? (
        <p
          style={{
            fontSize: "1rem",
            fontWeight: "700",
            color: "white",
            display: "flex",
            gap: "1rem",
          }}
        >
          Fetching data..{" "}
          <span style={{ paddingLeft: "10px", marginTop: "5px" }}>
            <FaSpinner />
          </span>
        </p>
      ) : (
        <>
          <div style={{ padding: 20 }}>
            <h2 style={{ color: "white" }}>NASDAQ-100 Daily Snapshot</h2>

            <table style={{ width: "100%", color: "white" }}>
              <thead>
                <tr style={{ color: "black" }}>
                  <th align="left">Symbol</th>
                  <th>Close</th>
                  <th>% Change</th>
                </tr>
              </thead>

              <tbody>
                {Object.values(dailyStore).map((stock) => (
                  <tr style={{ color: "black" }} key={stock.symbol}>
                    <td>{stock.symbol}</td>
                    <td>{stock.latest?.close ?? "-"}</td>
                    <td
                      style={{
                        color:
                          stock.latest?.percentChange > 0
                            ? "#2fd18a"
                            : "#f87171",
                        fontWeight: "bold",
                      }}
                    >
                      {stock?.latest?.percentChange ?? "-"}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default GlobalDaily;
